/// <amd-module name="Wit/Common/BacklogContentService/IHubContentService" />
import { IVssService } from "VSS/Platform/Context";
import { ITreeItemEx } from "VSSUI/Utilities/TreeItemProvider";
import { ExceptionInfoResult } from "Wit/Common/HubError/Models/Models";
import { IBacklogColumn, ICommonBacklogData } from "./BacklogContentDataProviderTypes";
import { IBacklogTreeRow } from "./BacklogContentTreeTypes";
import { FilterManager } from "Wit/Filter/FilterManager";

export interface IHubContentService extends IVssService {
    isReorderDisabled: boolean;
    getBacklogContents(options?: { ignoreCache: boolean }): Promise<ICommonBacklogData | ExceptionInfoResult>;
    getFilterKey(): string;
    getZeroDataPrimaryText(): string;
    getZeroDataSecondaryText(): string | JSX.Element;
    onIterationChange(workItems: ITreeItemEx<IBacklogTreeRow>[]): void;
    refreshTree(options?: { keepOpen?: boolean; filterManager?: FilterManager; ignoreBacklogConfigCache?: boolean }): void;
    settingsServiceResizeColumn(backlogColumnId: number, newWidth: number): Promise<void>;
    settingsServiceSetColumns(backlogColumns: IBacklogColumn[]): Promise<void>;
    settingsServiceGetColumns(): Promise<IBacklogColumn[]>;
}
